import { render, staticRenderFns } from "./UserStatus.vue?vue&type=template&id=6a55dec1&scoped=true&"
import script from "./UserStatus.vue?vue&type=script&lang=ts&"
export * from "./UserStatus.vue?vue&type=script&lang=ts&"
import style0 from "./UserStatus.vue?vue&type=style&index=0&id=6a55dec1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55dec1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VTooltip})
